import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeIn } from './ui/Section';
import { BookOpen, Clock, MessageCircle } from 'lucide-react';
export function PromiseSection() {
  return <Section className="bg-slate-50" data-id="element-271">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true
    }} variants={fadeIn} className="text-center max-w-3xl mx-auto mb-16" data-id="element-272">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-273">
          Inglés Nativo en 14 Días (USA)
        </h2>
        <p className="text-xl text-slate-600 leading-relaxed" data-id="element-274">
          Un PDF guiado con conversaciones reales para hispanohablantes que ya
          "entienden algo", pero se quedan en blanco al hablar.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-275">
        {[{
        icon: Clock,
        title: 'En 14 días',
        desc: 'Entrenas las 20 escenas que más te pasan en Estados Unidos.'
      }, {
        icon: MessageCircle,
        title: 'Frases Nativas',
        desc: 'Usando lo que un nativo realmente diría, no inglés de libro.'
      }, {
        icon: BookOpen,
        title: 'Respuestas Reales',
        desc: 'Guiones listos con variaciones para que nunca te quedes callado.'
      }].map((item, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-276">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6 text-blue-600" data-id="element-277">
              <item.icon className="w-6 h-6" data-id="element-278" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-279">
              {item.title}
            </h3>
            <p className="text-slate-600" data-id="element-280">{item.desc}</p>
          </motion.div>)}
      </div>
    </Section>;
}